module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "pgepubid00009"
    }
  }, [_vm._v("THE BOWL")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Some master-craftsman, maker of porcelains, to the Emperor, the Son of Heaven,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  Having attained the paradise of artists, who mould in life and fire,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  Fashioned this day:"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  A bowl blue as the iris within the sacred gardens,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  Based with a low design of brown bare hills,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  A pine or two new-tipped with tender needles,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  With oak buds, pink and saffron,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  And birds red, brown, and blue."), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  Into this bowl, exquisite and perishable,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  The Patron of all artists heaps light and more light;"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  Then holding high the brimming chalice, quaffs,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  And folds it in his altar-cloth of stars."), _c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "valediction"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("Carl H. Grabo")]), _vm._v(". ("), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("From the Nation")]), _vm._v(".)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2def1711","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0